export const CRM_MONTHLY_FEE = 99;
